import { observable } from '@legendapp/state';

import { deviceSettingStore } from './device-setting-store';

interface DegreeImageStore {
	currentDegree: number | null;
	isImageLoaded: boolean;
}

const isPortrait = deviceSettingStore.isPortrait.get();

export const degreeImageStore = observable<DegreeImageStore>({
	currentDegree: isPortrait ? 30 : 0,
	isImageLoaded: false
});

export const degreeImageStoreActions = {
	setCurrentDegree: (degree: number) => {
		degreeImageStore.currentDegree.set(degree);
	},
	setIsImageLoaded: (loaded: boolean) => {
		degreeImageStore.isImageLoaded.set(loaded);
	}
};
